import { type Experiment } from 'src/types/experiment';
import { initializeDatadog } from 'src/utils/datadog/initialize-datadog';

export const setupDatadogForWidgets = (experiments: Experiment[]) =>
  initializeDatadog('widgets', experiments);
